import ProductSuggestions from "./ProductSuggestions";

import "./ProductSuggestions.scss";

export * from "./ProductSuggestions.types";

export { ProductSuggestions };
